<div class="kt-modal" data-kt-modal="true" [id]="modalId">
  <div [class]="'kt-modal-content top-[10%] ' + widthClass">
    <div class="kt-modal-header">
      <h3 class="kt-modal-title">{{ title }}</h3>
      <button
        type="button"
        class="kt-modal-close"
        aria-label="Close modal"
        [attr.data-kt-modal-dismiss]="'#' + modalId"
        [disabled]="submitting"
        (click)="cancel.emit()"
      >
        <i class="ki-filled ki-cross" aria-hidden="true"></i>
      </button>
    </div>

    <div class="kt-modal-body">
      <ng-content select="[modal-body]"></ng-content>

      @if (formError) {
        <div class="kt-alert kt-alert-destructive mt-4" role="alert">
          <div class="kt-alert-text">{{ formError }}</div>
        </div>
      }
    </div>

    <div class="kt-modal-footer flex justify-end gap-2">
      <button
        type="button"
        class="kt-btn kt-btn-light"
        [attr.data-kt-modal-dismiss]="'#' + modalId"
        [disabled]="submitting"
        (click)="cancel.emit()"
      >
        {{ cancelLabel }}
      </button>
      @if (showSubmit) {
        <button type="button" class="kt-btn" (click)="submit.emit()" [disabled]="submitting">
          <span class="inline-flex items-center gap-2">
            @if (submitting) {
              <span class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-r-transparent" aria-hidden="true"></span>
            }
            <span>{{ submitLabel }}</span>
          </span>
        </button>
      }
    </div>
  </div>
</div>
